import { Chart } from 'chart.js/auto';
import { MatrixController, MatrixElement } from 'chartjs-chart-matrix';
import Hammer from 'hammerjs';
import zoomPlugin from 'chartjs-plugin-zoom';

window.Hammer = Hammer;
Chart.register(MatrixController, MatrixElement, zoomPlugin);

export { Chart };

